import React from 'react'

const UserActionReport = () => {
  return (
    <div>UserActionReport</div>
  )
}

export default UserActionReport